<template>
    <div class="auth" v-if="!loading">
        <public-header />
        <v-main class="content">
            <router-view></router-view>
        </v-main>
        <public-footer />
    </div>
</template>
<script>
import Vue from "vue";

import loader from "src/mixins/loader";
import PublicFooter from "src/components/footer/Footer.vue";
import PublicHeader from "src/components/header/public/Header.vue";
import { Services } from "src/services/Services.js";

export default Vue.extend({
    mixins: [loader],
    data() {
        return {
            loading: true,
        };
    },
    components: {
        PublicHeader,
        PublicFooter,
    },
    async beforeCreate() {
        try {
            const user = await Services.api.user.getMe();
            if (user) this.$router.push({ name: "espace-client" });
        } catch (error) {
            console.log(error);
        } finally {
            this.loading = false;
        }
    },
});
</script>

<style lang="sass" scoped>
::v-deep
    a
        text-decoration: none
        color: $color-text
.auth
    display: flex
    flex-direction: column
    flex: 1 0 auto
.content
    background: url(./cover.jpg)
    background-size: cover
    background-position: center
    display: flex
    align-items: center
</style>
